/**
 * Default localized text (US English).
 */
export type Locale = Partial<typeof locale>

const locale = {
  loading: "Loading"
}

export default locale
